import { Roles } from '../utils';
import {
  RECOGNITION_NOTICE_LEVEL_WARNING,
  RECOGNITION_NOTICE_LEVEL_LIMIT_REACHED,
} from '../types';

export const getCurrentProject = (app) => {
  const { user, currentProjectId } = app;
  if (!user || !user.projects) {
    return null;
  }

  const [project] = user.projects.filter(i => i.id === currentProjectId);

  return project || null;
};

export const userRoleInCurrentProject = (app) => {
  const { roles, user } = app;

  if (user.super_admin) {
    return Roles.role_super_admin.id;
  }

  const project = getCurrentProject(app);

  if (project && project.role_id) {
    const [role] = roles.filter(i => i.id === project.role_id);
    return role ? role.code : null;
  } else {
    return null;
  }
};

/**
 * Recognition notice to display, or null. Only `level` is used to decide;
 * the warning can be closed for the current session, the limit notice cannot.
 */
export const getVisibleRecognitionNotice = (app) => {
  const notice = app.user && app.user.recognition_notice;
  if (!notice) {
    return null;
  }

  if (notice.level === RECOGNITION_NOTICE_LEVEL_LIMIT_REACHED) {
    return notice;
  }

  if (notice.level === RECOGNITION_NOTICE_LEVEL_WARNING
    && app.recognitionNoticeDismissedLevel !== RECOGNITION_NOTICE_LEVEL_WARNING) {
    return notice;
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/selectors/app.js